import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'api';
import { getErrorHandler } from 'utils/getErrorHandler';
import { message } from 'antd';
import { queryKeys } from 'utils/queryKeys';

export const useBulkLinkSharing = () => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: async (invites) => {
      const { data } = await api.sendInvitesBulk({ invites });

      return data;
    },
    onSuccess: async () => {
      message.success('Invite(s) sent successfully');
      await queryClient.invalidateQueries({
        queryKey: queryKeys.shareLinksQuota(),
      });
    },
    onError: getErrorHandler('Unable to invite'),
  });

  return {
    sendInvitesBulk: mutate,
    isLoading,
  };
};
